import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { REPORT } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const initialState = {
	analysis: {
		data: null,
		isLoading: true
	},
	weeklyAnalysis: {
		data: null,
		isLoading: true
	},
	dcAnalysis: {
		data: null,
		isLoading: true
	}
};

export const getAnalysisData = createAsyncThunk('aggregatorAging/analysis', async (filters, { rejectWithValue }) => {
	const axiosPrivate = useAxiosPrivate();
	try {
		const response = await axiosPrivate.post(REPORT.DELIVERY_COMPANY.GET_AGGREGATOR_AGING_ANALYSIS, {
			totalRecord: false,
			filter: filters
		});
		return response.data;
	} catch (error) {
		AppLogger.error(error);
		throw rejectWithValue(error);
	}
});

export const getDCAnalysisData = createAsyncThunk(
	'aggregatorAging/dcAnalysis',
	async (filters, { rejectWithValue }) => {
		const axiosPrivate = useAxiosPrivate();
		try {
			const response = await axiosPrivate.post(REPORT.DELIVERY_COMPANY.GET_AGGREGATOR_AGING_DC_ANALYSIS, {
				totalRecord: false,
				filter: filters
			});
			return response.data.data;
		} catch (error) {
			AppLogger.error(error);
			throw rejectWithValue(error);
		}
	}
);

export const getWeeklyAnalysisData = createAsyncThunk(
	'aggregatorAging/weeklyAnalysis',
	async (_, { rejectWithValue }) => {
		const axiosPrivate = useAxiosPrivate();
		try {
			const response = await axiosPrivate.post(REPORT.DELIVERY_COMPANY.GET_AGGREGATOR_AGING_WEEKLY_ANALYSIS, {
				totalRecord: false
			});
			return response.data.data;
		} catch (error) {
			AppLogger.error(error);
			throw rejectWithValue(error);
		}
	}
);

const aggregatorAging = createSlice({
	name: 'aggregatorAging',
	initialState,
	extraReducers: (builder) => {
		builder
			.addCase(getAnalysisData.pending, (state) => ({
				...state,
				analysis: {
					...state.analysis,
					isLoading: true
				}
			}))
			.addCase(getAnalysisData.fulfilled, (state, { payload }) => ({
				...state,
				analysis: {
					data: payload,
					isLoading: false
				}
			}))
			.addCase(getAnalysisData.rejected, (state) => ({
				...state,
				analysis: {
					data: null,
					isLoading: false
				}
			}));
		builder
			.addCase(getDCAnalysisData.pending, (state) => ({
				...state,
				dcAnalysis: {
					...state.dcAnalysis,
					isLoading: true
				}
			}))
			.addCase(getDCAnalysisData.fulfilled, (state, { payload }) => ({
				...state,
				dcAnalysis: {
					data: payload,
					isLoading: false
				}
			}))
			.addCase(getDCAnalysisData.rejected, (state) => ({
				...state,
				dcAnalysis: {
					data: null,
					isLoading: false
				}
			}));
		builder
			.addCase(getWeeklyAnalysisData.pending, (state) => ({
				...state,
				weeklyAnalysis: {
					...state.weeklyAnalysis,
					isLoading: true
				}
			}))
			.addCase(getWeeklyAnalysisData.fulfilled, (state, { payload }) => ({
				...state,
				weeklyAnalysis: {
					data: payload,
					isLoading: false
				}
			}));
	}
});

export default aggregatorAging.reducer;
